module.exports = __webpack_public_path__ + "static/media/026-customer-service.06febcf9.svg";